import { useSession } from "@/context/SessionProvider";
export function useUser() {
    const { user } = useSession();
    return user;
}
